// extracted by mini-css-extract-plugin
export default {"link":"Navigation_link__uKevN","link__active":"Navigation_link__active__tTpxM"};